<div class="fluid grid">
  <div class="col-4">
    <p-calendar [(ngModel)]="dateValue"
                dateFormat="dd.mm.yy"
                selectOtherMonths="true"
                firstDayOfWeek="1"
                (onSelect)="onDateSelect($event)">
    </p-calendar>
  </div>
</div>
<div class="fluid grid">
  <div class="p-flex-row col-12">
    <p-chart type="bar"
             [data]="dataMonthlyClientsPayments"
             [options]="monthlyClientsOptions"
             (onDataSelect)="selectData($event)"
             width="100%"
             height="20rem">
    </p-chart>
  </div>
</div>
